import { useQuery } from '@tanstack/react-query';
import { request } from '../services/request';
import { RootObject, RootObjectMyCredential } from '../types/allcredential';

export const useMyCredentials = () => {
    return useQuery<RootObjectMyCredential, Error>(['my-credentials'], async () => {
        const jsonResponse = await request({
            endpoint: 'credentials/my-credentials'
        });

        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }

        return jsonResponse;
    },{
    refetchOnWindowFocus: false,  
    });
};
